import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { useAuth } from '../context/AuthContext';
import { installComponentTemplate, listComponentTemplates } from '../services/componentService';

function Marketplace() {
  const { currentUser } = useAuth();
  const [components, setComponents] = useState([]);
  const [includeAdult, setIncludeAdult] = useState(false);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function loadComponents() {
      setLoading(true);
      setError('');
      try {
        const loadedComponents = await listComponentTemplates({ includeAdult });
        if (active) {
          setComponents(loadedComponents);
        }
      } catch (err) {
        if (active) {
          setError(err.message);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadComponents();

    return () => {
      active = false;
    };
  }, [includeAdult]);

  async function handleInstall(template) {
    setSavingId(template.id);
    setMessage('');
    setError('');
    try {
      await installComponentTemplate(currentUser.uid, template, 0);
      setMessage(`${template.name} installed. Configure it from Site Theme or Daily.`);
    } catch (err) {
      setError(err.message);
    } finally {
      setSavingId('');
    }
  }

  return (
    <>
      <SEO title="Marketplace" />
      <section className="page-heading">
        <p className="eyebrow">Free sharing first</p>
        <h1>A marketplace for autobiography components.</h1>
        <p>Install safe profile blocks, daily practices, games, and data views without adding clutter to your workspace.</p>
        <label className="inline-toggle">
          <input type="checkbox" checked={includeAdult} onChange={(event) => setIncludeAdult(event.target.checked)} />
          Show NSFW / 18+ components
        </label>
      </section>
      {error && <p className="error-text">{error}</p>}
      {message && <p className="notice">{message}</p>}
      {loading ? <p className="surface-card">Loading marketplace components...</p> : null}
      <section className="feature-grid">
        {components.map((component) => (
          <article className="surface-card" key={component.id}>
            <p className="tag">{component.creatorId === 'platform' ? 'Default component' : 'Community component'} · {component.kind}</p>
            <h2>{component.name}</h2>
            <p>{component.description}</p>
            {component.nsfw || component.adult ? <p className="tag">NSFW / 18+</p> : null}
            <p className="muted">Default: {component.defaultVisibility} · {component.placement}</p>
            {currentUser ? (
              <button className="button button-secondary" type="button" disabled={savingId === component.id} onClick={() => handleInstall(component)}>
                {savingId === component.id ? 'Installing...' : 'Install component'}
              </button>
            ) : (
              <Link className="button button-secondary" to="/login">Log in to install</Link>
            )}
          </article>
        ))}
      </section>
    </>
  );
}

export default Marketplace;
